export type PollingState = {
  isPolling: boolean;
  timer?: ReturnType<typeof setTimeout>;
  callTime?: number;
}

export const polling: PollingState = {
  isPolling: false,
  timer: undefined,
  callTime: undefined
};
